const dateFormat = function(value,fmt,now) {
  if (!value) return "";
  value = now ? "" : value;


  if (typeof (value) === 'string' && !value.includes('T')) {
      value = value.replace(/-/g, "/");
  }

  let date = new Date(value);
  let ret;
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      }
  }
  return fmt;
}
const defaultText = function(value,repeat=2) {
    let val = "";
    if(value){
        val = value;
    }else{
        if(repeat != 2){
            for(let i = 0; i < repeat; i++){
                val += "-";
            }
        }else{
            val = "--";
        }
    }
    return val;
}
const splitK =  function(num,int) {
	if(num || num ===0){
		num = Number(num).toFixed(2);
		let fh = "";
		num = String(num);
		if(num.indexOf('-')>-1){
			fh = '-';
			num = num.slice(1);
		}
		let decimal = String(num).split('.')[1] || '00';//小数部分
	   	let tempArr = [];
	   	let revNumArr = String(num).split('.')[0].split("").reverse();//倒序
	   	for (let i in revNumArr){
	     	tempArr.push(revNumArr[i]);
	     	if((i+1)%3 === 0 && i != revNumArr.length-1){
	      		tempArr.push(',');
	        }
	    }
	    let zs = tempArr.reverse().join('');//整数部分
	    if(!int) return decimal?fh+zs+'.'+decimal:fh+zs;
	    if(int) return fh+zs;
	}
	return "0.00";
}
const phoneFilter = function(phone){
    if(String(phone).length == 11){
        return phone.substring(0,3) + "****" + phone.substring(7);
    }
    return "phone";
}
export default {
    dateFormat,
    defaultText,
    splitK,
    phoneFilter
}



// WEBPACK FOOTER //
// ./src/filters/common-filter.js